import { PerspectiveCamera } from 'three';

export function Camera (sizes:any, scene:any, gui:any)
{
	const camera:any = new PerspectiveCamera(30, sizes.width / sizes.height, 0.1, 100);
	camera.position.x = 0;
	camera.rotation.x = 0.3;
	scene.add(camera);

	const reposCamera:any = ()=>{
		if(document.body.clientWidth<768){
			camera.position.y = -1;
			camera.position.z = 5;
		}else{
			camera.position.y = 0;
			camera.position.z = 3.5;
		}
	}
	window.addEventListener('resize', () =>
	{
		// Update sizes
		reposCamera();
	})
	reposCamera();

	// document.addEventListener("mousemove", (event:any) => {
	// 	const centerX:any = window.innerWidth/2;
	// 	const centerY:any = window.innerHeight/2;

	// 	const x:any = event.clientX-centerX;
	// 	const y:any = event.clientY-centerY;

	// 	camera.rotation.x = -(y/centerY)*.05;
	// 	camera.rotation.y = -(x/centerX)*.05;
	// });
	
	//DEBUG
	// const cameraFolder = gui.addFolder('Camera');
	// cameraFolder.add(camera.rotation, 'x', -10, 10);
	// cameraFolder.add(camera.rotation, 'y', -10, 10);
	// cameraFolder.add(camera.rotation, 'z', -10, 10);
	// cameraFolder.add(camera.position, 'x', -10, 10);
	// cameraFolder.add(camera.position, 'y', -10, 10);
	// cameraFolder.add(camera.position, 'z', -10, 10);
	// cameraFolder.open();

	return camera;
}